// src/features/business-functions/constants/accountConstants.js
import { CAMPAIGN_COPY } from './campaignCopy';

/** Config-driven tab definitions — append new tabs here without structural refactoring. */
export const ACCOUNT_TAB_CONFIG = [
  { key: 'workspaces', label: CAMPAIGN_COPY.tab.label },
  { key: 'details', label: 'Account Details' },
];

export const DEFAULT_ACCOUNT_TAB = 'workspaces';

/** Account status values — keep in sync with backend AccountViewSet */
export const ACCOUNT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const ACCOUNT_STATUS_COPY = {
  active: 'Active',
  inactive: 'Inactive',
  activated: 'Business function activated',
  deactivated: 'Business function deactivated',
  toggleFailed: 'Unable to update business function status',
  unavailable: 'This business function is inactive.',
  statusHelper: 'Status is managed by a platform administrator.',
};

/** Analytics period presets for the overview charts */
export const ANALYTICS_PERIODS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
];

export const DEFAULT_ANALYTICS_PERIOD = '30d';

/** Chart type options for the overview analytics panel */
export const CHART_TYPES = [
  { value: 'area', label: 'Area' },
  { value: 'bar', label: 'Bar' },
  { value: 'line', label: 'Line' },
];

export const DEFAULT_CHART_TYPE = 'area';

/** Workspace icon mapping — maps workspace type to MUI icon name + accent key */
export const WORKSPACE_ICON_MAP = {
  lead_management: { icon: 'Groups', colorKey: 'success' },
  sales_pipeline: { icon: 'FilterAlt', colorKey: 'info' },
  customer_management: { icon: 'PersonOutline', colorKey: 'warning' },
  reports: { icon: 'Assessment', colorKey: 'info' },
  tasks: { icon: 'TaskAlt', colorKey: 'danger' },
  documents: { icon: 'Description', colorKey: 'success' },
  default: { icon: 'FolderOpen', colorKey: 'info' },
};
